import React, {useEffect, useState} from "react";
import Button from "@mui/material/Button";
import DisplayCard, {CARD_ASPECT_RATIO} from "./DisplayCard";

const ANIM_MS = 250;

/**
 * Displays cards the player just drew, one at a time, as a near-fullscreen
 * popup that grows in and shrinks out. Draw events can arrive faster than the
 * player dismisses them, so they queue up: the popup always shows queue[0],
 * and clicking "Ok" plays the shrink animation before advancing to the next
 * card already waiting in the queue.
 */
export const DrawCardPopup = ({queue, onDismissTop}) => {
    const [current, setCurrent] = useState(null); // {card, phase: "entering" | "visible" | "leaving"}

    useEffect(() => {
        if (!current && queue.length > 0) {
            setCurrent({card: queue[0], phase: "entering"});
        }
    }, [queue, current]);

    useEffect(() => {
        if (current && current.phase === "entering") {
            const timer = setTimeout(() => {
                setCurrent(c => (c && c.phase === "entering" ? {...c, phase: "visible"} : c));
            }, ANIM_MS);
            return () => clearTimeout(timer);
        }
    }, [current]);

    if (!current) return null;

    const handleOk = () => {
        setCurrent(c => (c ? {...c, phase: "leaving"} : c));
        setTimeout(() => {
            onDismissTop();
            setCurrent(null);
        }, ANIM_MS);
    };

    return (
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            zIndex: 1400,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <div style={{
                width: "90vw",
                maxWidth: "520px",
                height: "90vh",
                boxSizing: "border-box",
                padding: "24px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#191b31",
                border: "2px solid #10346f",
                borderRadius: "24px",
                boxShadow: "black 0 1px 10px",
                animation: (current.phase === "leaving" ? "draw-card-popup-shrink" : "draw-card-popup-grow")
                    + " " + ANIM_MS + "ms ease-out forwards"
            }}>
                <h2 style={{color: "#FFF", marginBottom: "16px", textAlign: "center"}}>
                    Vous avez pioché :
                </h2>
                <div style={{
                    flex: 1,
                    minHeight: 0,
                    width: "100%",
                    aspectRatio: CARD_ASPECT_RATIO
                }}>
                    <DisplayCard card={current.card}/>
                </div>
                <Button
                    variant="contained"
                    onClick={handleOk}
                    sx={{marginTop: "24px", minWidth: "120px"}}
                >
                    Ok
                </Button>
            </div>
        </div>
    );
};

export default DrawCardPopup;
